<template>
  <div>
    <label
      class="label"
      :for="id"
    >{{ label }}</label>
    <div class="form__row form__row--phone">
      <vue-tel-input
        v-model="inputPhone"
        :input-options="{ id: id }"
        class="input"
        :class="{ 'input--error': !!errorMessage }"
        mode="national"
        default-country="US"
        :preferred-countries="['US']"
        @input="onInput"
      />
    </div>
    <p
      v-if="enableSmsNote"
      class="form__note"
    >
      We'll send a text or call you to verify your phone.
    </p>
    <p
      v-if="errorMessage"
      class="form__error"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>
<script>

export default {
  inheritAttrs: false,
  props: {
    id: String,
    value: String,
    label: String,
    errorCode: String,
    error: String,
    type: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      inputPhone: this.value,
      phoneObject: {
        country: null,
        countryCallingCode: '',
        countryCode: '',
        formatted: null,
        nationalNumber: null,
        number: null,
        valid: false,
      },
    };
  },
  computed: {
    enableSmsNote() {
      return this.$store.state.enableSms && !this.$store.state.phoneVerification.confirmed.success && !this.$store.state.phoneVerification.confirmed.error;
    },
    isInternationalNumber() {
      return +this.phoneObject.countryCallingCode !== 1;
    },
    phoneNumber() {
      return this.phoneObject.number;
    },
    errorMessage() {
      if (this.errorCode
        && this.$store.state.order.errorList
        && this.$store.state.order.errorList.includes(this.errorCode)) {
        return 'Please update this field to finish signing up';
      }
      if (this.error) {
        return this.error;
      }
      return null;
    },
  },
  methods: {
    onInput(_, phoneObject) {
      this.phoneObject = phoneObject;
      this.$emit('input', this.phoneNumber);
    },
  },
};
</script>

<style>
input#phone {
  border: 0;
}
</style>
